exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-video[data-v-30f547ba]{-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.product-video .gallery-video[data-v-30f547ba]{top:0}.product-video .iframe-wrapper[data-v-30f547ba]{left:0}.product-video .iframe-wrapper .iframe-container[data-v-30f547ba]{padding-top:56.25%}.product-video .iframe-wrapper .iframe-container iframe[data-v-30f547ba]{top:0;left:0;border:none}\n", ""]);

// exports
